<div mat-dialog-title class="dialog-title p-3">
  <h5>{{ risk_type + ' ' + title }}</h5>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <app-risk-matrix (selectedRiskLevel)="getRiskLevel($event)" [enableInteractiveMode]="true" [gridData]="chartData" [riskLevelData]="risk_level" [riskMatrixTitle]="title"></app-risk-matrix>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="px-3 py-2">
  <button
    mat-raised-button
    class="save-button my-2 ml-1 mr-2"
    type="button"
    style="max-width: none;"
    color="primary"
    matTooltip="Select the Likelihood and {{ utils.getLangTerm('hazards.form.severity', 'Severity') }} to map the risk level using the risk matrix for the {{ risk_type }} risk assessment."
    (click)="saveRiskLevel()"
    id="save">
    <mat-icon>save</mat-icon>
    Use Risk Level
  </button>

  <button
    *ngIf="app.account.company_risk_matrix_url"
    mat-raised-button
    class="save-button my-2 ml-1 mr-2"
    type="button"
    style="max-width: none;"
    color="secondary"
    matTooltip="View the risk matrix Definition."
    (click)="onViewCompanyRiskMatrix()">
    <mat-icon>assessment</mat-icon>
    View Risk Matrix Definition
  </button>

  <button
    mat-raised-button
    class="my-2 ml-1 ml-lg-auto"
    type="button"
    color="secondary"
    [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
    Cancel
  </button>
</mat-dialog-actions>
